import { LAYOUT_MODE_TYPES } from '../../Components/constants/layout';

type StoredLayoutMode = LAYOUT_MODE_TYPES.LIGHTMODE | LAYOUT_MODE_TYPES.DARKMODE;

const layoutModeStorageKey = 'plain-provider-layout-mode';

const isStoredLayoutMode = (value: string | null): value is StoredLayoutMode => (
    value === LAYOUT_MODE_TYPES.LIGHTMODE || value === LAYOUT_MODE_TYPES.DARKMODE
);

const getStoredLayoutMode = (): StoredLayoutMode => {
    try {
        if (typeof window === 'undefined') {
            return LAYOUT_MODE_TYPES.LIGHTMODE;
        }

        const storedLayoutMode = window.localStorage.getItem(layoutModeStorageKey);
        return isStoredLayoutMode(storedLayoutMode) ? storedLayoutMode : LAYOUT_MODE_TYPES.LIGHTMODE;
    } catch (error) {
        return LAYOUT_MODE_TYPES.LIGHTMODE;
    }
};

const persistLayoutMode = (layoutMode: string): void => {
    try {
        if (typeof window !== 'undefined' && isStoredLayoutMode(layoutMode)) {
            window.localStorage.setItem(layoutModeStorageKey, layoutMode);
        }
    } catch (error) {
        // Ignore unavailable storage and still allow the in-memory theme switch.
    }
};

/**
 * Changes the body attribute
 */
const changeHTMLAttribute = (attribute: string, value: string): boolean => {
    if (document.documentElement) {
        document.documentElement.setAttribute(attribute, value);
    }
    return true;
};

export { changeHTMLAttribute, getStoredLayoutMode, persistLayoutMode };
